module.exports = __webpack_public_path__ + "img/phone-bg.daeb405a.png";